/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import cogoToast from "cogo-toast";
import DeleteModal from './deleteModal'


function PurchaseOrderActionButton(props) {
    const [purchaseOrderId, setPurchaseOrderId] = useState('')
    const [openBox, setopenBox] = useState(false)

    let handleDelete = () => {
        props.data.deletePurchaseOrder(props.data.refNo)
    }

    let handleEdit = (e) => {
        let purchaseOrder = props.data
        let history = props.agGridReact.props.baseURL.history
        history.push({ pathname: '/edit-purchaseorder' , state: { id: purchaseOrder.poId, vendorId: purchaseOrder.vendorId }})
    }

    let handleOpenDelete = (e) => {
        let mainData = props.data
        setPurchaseOrderId(mainData.id)
        setopenBox(true)
    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }

    let purchaseOrder = props.data

    return (
        <>
            <Button onClick={handleEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <DeleteModal open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} isLoading={props.data.isLoading} /> 
        </>
    )
}

export default PurchaseOrderActionButton